import * as React from 'react';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLayoutGrid } from 'uitk-react-layout-grid';

import { Viewport, ViewSmall, ViewLarge } from 'bernie-view';
import { AdvancedSearchOption } from './search-options';
import { FlightsSearchFormOptionType } from 'src/types/search/wizard';
import { InteractableFieldComponentProps } from 'types/shared';

export interface SearchFormOptionsProps extends InteractableFieldComponentProps {
  options: FlightsSearchFormOptionType[];
}

export const SearchFormOptions = ({ options, onFieldInteraction }: SearchFormOptionsProps) => {
  const classNames = 's-y-padding-three m-y-padding-three';

  return (
    <Viewport>
      <ViewSmall>
        <>
          <hr />
          <UitkLayoutGrid space="three" columns={2} className={classNames}>
            {options.map(option => (
              <AdvancedSearchOption
                key={`search-form-advanced-option-${option.label}`}
                searchOption={option}
                onFieldInteraction={onFieldInteraction}
              />
            ))}
          </UitkLayoutGrid>
        </>
      </ViewSmall>
      <ViewLarge>
        <UitkLayoutFlex space="one" wrap="wrap" className={classNames}>
          {options.map(option => (
            <AdvancedSearchOption
              key={`search-form-advanced-option-${option.label}`}
              searchOption={option}
              onFieldInteraction={onFieldInteraction}
            />
          ))}
        </UitkLayoutFlex>
      </ViewLarge>
    </Viewport>
  );
};
